import { WE_CHAT_OFFICIAL_ACCOUNT_APP_ID } from "utils/Config";
export function requestMiniProgramLocation({ onSuccess, onFailed, onCancel }) {
    if (!window.wx) {
        return
    }
    window.wx.getLocation({
        type: 'wgs84',
        success: function (res) {
            console.log("getLocation success:", res)
            onSuccess && onSuccess(res)
        },
        fail: function (err) {
            console.log("getLocation fail:", err)
            onFailed && onFailed(err.errMsg)
        },
        cancel: function (res) {
            console.log("getLocation cancel:", res)
            onCancel && onCancel()
        }
    });
}

export function requestMiniProgramScan({ onSuccess, onFailed, onCancel }) {
    if (!window.wx) {
        return
    }
    window.wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
            const result = res.resultStr;
            console.log("scanQRCode success:", result)
            onSuccess && onSuccess(result)
        },
        fail: function (err) {
            console.log("scanQRCode error:", err)
            onFailed && onFailed(err.errMsg)
        },
        cancel: function (res) {
            console.warn('scanQRCode cancel:', res);
            onCancel && onCancel()
        }
    });
}

export function requestMiniProgramChooseImage({ onSuccess, onFailed, onCancel }) {
    if (!window.wx) {
        return
    }
    window.wx.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function (res) {
            const localIds = res.localIds;
            console.log("chooseImage success:", localIds)
            onSuccess && onSuccess(localIds)
        },
        fail: function (err) {
            console.log("chooseImage fail:", err)
            onFailed && onFailed(err.errMsg)
        },
        cancel: function (res) {
            console.warn('chooseImage cancel:', res);
            onCancel && onCancel()
        }
    });
}

export function inMiniProgram() {
    if (window.__wxjs_environment === "miniprogram") {
        return true
    }
    const ua = window.navigator.userAgent.toLowerCase()
    const isWXWork = ua.match(/wxwork/i) && ua.match(/wxwork/i)[0] === 'wxwork'
    const isWeixinMiniProgram = !isWXWork && ua.match(/miniprogram/i) && ua.match(/miniprogram/i)[0] === 'miniprogram'
    return isWeixinMiniProgram
}

export function setWeChatConfig(timestamp, nonceStr, signature) {
    if (!window.wx) {
        return
    }
    window.wx.config({
        debug: false,
        appId: WE_CHAT_OFFICIAL_ACCOUNT_APP_ID,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ["scanQRCode", "getLocation", "chooseImage"]
    });
}

